module.exports = __webpack_public_path__ + "img/g2.352058d5.png";